// extracted by mini-css-extract-plugin
export default {"tagContainer":"CallTags_tagContainer__i+jjZ","tag":"CallTags_tag__3-kdY"};